import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage, useFormikContext } from "formik";
import InputLayout from "../../../atoms/InputLayout";
import * as Yup from "yup";
import CountryCodeDropdown from "../../../molecules/Dropdown/CountryCodeDropdown";
import Error from "../../../atoms/Error";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { postData, patchData, getData, deleteData } from "../../../../services";
import { useCookies } from "react-cookie";
import toast from "react-hot-toast";
import {
  confimationStyles,
  errorStyles,
} from "../../../../assets/styles/toast";
import {
  statusData,
  Priorities,
  ProjectStatus,
  TaskType,
  TaskStatus,
} from "../../../../helpers/staticData";
import SelectDropdown from "../../../molecules/Dropdown";
import { MonthYearSelector } from "../../../organisms/MonthYearSelector";
import { DateSelector } from "../../../organisms/MonthYearSelector";
import QuillEditor from "../../../organisms/QuillEditorBasic";
import {
  UploadedFilesComponent,
  AttachmentComponent,
} from "../../../organisms/AttachmentComponent";
import DangerousHTML from "react-dangerous-html";
import CustomButton from "../../../atoms/CustomButton";
import { Hourglass, Edit, Trash2 } from "lucide-react";
import LogTime, { LogButton, LoggedEntries } from "./LogTime";
import Recurring from "./Recurring";
import { useParams } from "react-router-dom";
import { getTaskLogTime } from "../../../../services/basicGets";
import moment from "moment";
import { frequencyOptions } from "../../../../helpers/staticData";
import ClientDropdown from "../../../organisms/ClientDropdown";
import TeamDropdown from "../../../organisms/TeamDropdown";
import { decodeCookieValue } from "../../../../helpers/cookieHelper";
import SubtaskView from "./Subtask";
import StatusBackground from "../../../atoms/StatusBackground"; // Adjust path as needed
import StatusSelector from "../../../atoms/StatusSelector";
import DeleteModal from "../../../organisms/modals/DeleteModal";
import { getEmployeeList } from "../../../../services/basicGets";

const TaskForm = ({
  onFormDirty,
  initialData,
  onClose,
  refetchData,
  // employeeList,
  Projects,
  rolesList,
  teamList,
  clientList,
  information,
  refetchClientList,
  mytask,
  departmentList,
  setLogModalOpen,
  type,
  isAdmin,
}) => {
  const [cookies] = useCookies(["e_t", "euid", "e_n"]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [logTimerOpen, setLogTimerOpen] = useState(false);
  const [subtaskOpen, setSubtaskOpen] = useState(false);
  const [logData, setLogData] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [subtask, setSubtask] = useState({
    subtasks: initialData?.subtasks || [],
  });
  const [filteredAssignedTo, setFilteredAssignedTo] = useState(employeeList);
  const [filteredAssignedTeams, setFilteredAssignedTeams] = useState(teamList);
  const [isLogDataDirty, setIsLogDataDirty] = useState(false);
  const [dirtyFlag, setDirtyFlag] = useState(false);
  const [client, setClient] = useState(clientList || []);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedSubtaskForDeletion, setSelectedSubtaskForDeletion] =
    useState(null);
  const [isConfirmCompleteModalOpen, setIsConfirmCompleteModalOpen] =
    useState(false); // New state for confirmation modal
  const [pendingStatus, setPendingStatus] = useState(null);
  const [originalStatus, setOriginalStatus] = useState(
    initialData?.status || "New Task"
  );
  const [isUploading, setIsUploading] = useState(false);
  const [endRepeats, setEndRepeats] = useState(false);

  const teamIds = initialData?.assigned_teams?.map((team) => team?.team_id);
  const employeeIds = initialData?.assigned_employees?.map(
    (emp) => emp.employee_id
  );

  const isAllowed = initialData?.allowed_to_log_time;

  const fetchLogTime = async () => {
    const res = await getTaskLogTime({
      task_id: initialData?.id,
      token: cookies.e_t,
    });
    setLogData(res?.data);
  };

  const completedsubtask = subtask.subtasks.filter(
    (sub) => sub.status === "Completed"
  ).length;
  const totalsubtask = subtask.subtasks.length;

  const confirmcomplete = totalsubtask - completedsubtask;

  const getAllSubtask = async () => {
    try {
      const response = await getData({
        endpoint: "Subtask/getAllSubtasksByTaskId",
        token: cookies.e_t,
        params: { taskId: initialData.id },
      });
      setSubtask({ subtasks: response?.data || [] });
    } catch (err) {
      console.error("Failed to fetch subtasks:", err);
      setSubtask({ subtasks: [] });
    }
  };

  useEffect(() => {
    if (initialData?.id) {
      fetchLogTime();
      getAllSubtask();
    }

    const projectId = initialData?.project_id;
    const infoId = information?.id;

    if (projectId) {
      newListsAssignTeam(projectId);
      newListsAssignTo(projectId);
    } else if (infoId) {
      newListsAssignTeam(infoId);
      newListsAssignTo(infoId);
    }

    setOriginalStatus(initialData?.status || "New Task");
  }, [initialData, information?.id]);

  // const initialValues = {
  //   id: initialData?.id || null,
  //   name: initialData?.name || "",
  //   priority: initialData?.priority || "",
  //   client_id: initialData?.client_id || null,
  //   due_date: initialData?.due_date || null,
  //   assigned_employees: employeeIds?.length > 0 ? employeeIds : [cookies.euid],
  //   type: initialData?.type || "Task",
  //   assigned_teams: teamIds || null,
  //   status: initialData?.status || "New Task",
  //   description: initialData?.description || "",
  //   project_id: information?.id || initialData?.project_id || null,
  //   media: initialData?.media || [],
  //   is_recurring: initialData?.is_recurring || null,
  //   recurrence_type: initialData?.recurrence_type || "",
  //   start_date: initialData?.start_date || null,
  //   end_time: initialData?.end_time || null,
  // };

  const initialValues = {
    id: initialData?.id || null,
    name: initialData?.name || "",
    priority: initialData?.priority || "",
    client_id: initialData?.client_id || null,
    due_date: initialData?.due_date || null,
    assigned_employees: employeeIds?.length > 0 ? employeeIds : [cookies.euid],
    type: initialData?.type || "Task",
    assigned_teams: teamIds || null,
    status: initialData?.status || "New Task",
    description: initialData?.description || "",
    project_id: information?.id || initialData?.project_id || null,
    media: initialData?.media || [],

    // Existing recurring fields
    is_recurring: initialData?.is_recurring || false,
    recurrence_type: initialData?.recurrence_type || "",
    start_date: initialData?.start_date || null,
    end_time: initialData?.end_time || null,

    // New recurring fields - Add these missing fields
    repeat_interval: initialData?.repeat_interval || 1,
    week_days: initialData?.week_days || null, // [Sun,Mon,Tue,Wed,Thu,Fri,Sat]
    month_days: initialData?.month_days || null, // [day1,day2,...,day31]
    skip_weekends: initialData?.skip_weekends || false,
    due_date_offset: initialData?.due_date_offset || "same_day",
    custom_due_date_offset: initialData?.custom_due_date_offset || 0,
    end_condition: initialData?.end_condition || "end_date",
    occurrence_count: initialData?.occurrence_count || 0,
    default_status: initialData?.default_status || "In Progress",
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Task Title is required"),
    priority: Yup.string().required("Priority is required"),
    type: Yup.string().required("Assigned task is required"),
    project_id: Yup.string().required("Project is required"),
    client_id: Yup.string().required("Client is required"),
    status: Yup.string().required("Status is required"),
    due_date: Yup.date().nullable(),
  });

  const handleSubmit = async (values, { resetForm }) => {
    setIsSubmitting(true);
    try {
      const res = await postData({
        endpoint: "Task/createTask",
        data: {
          ...values,
          description: values.description,
          created_by: cookies.euid,
          subtasks: subtask.subtasks,
          ...(values.recurrence_type && values.start_date && values.end_time
            ? { is_recurring: true }
            : {}),
        },
        token: cookies.e_t,
      });

      if (res) {
        toast.success("Task Created Successfully", {
          style: confimationStyles,
          duration: 1000,
        });
        resetForm();
        setSubtask({ subtasks: [] });
        onClose();
        refetchData();
      }
    } catch (err) {
      toast.error("Error Creating Task", { style: errorStyles });
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    (async () => {
      const resEmployee = await getEmployeeList({
        params: {
          ...(!isAdmin && { employee_id: cookies.euid }),
          status: JSON.stringify(["Active"]),
        },
        token: cookies.e_t,
      });

      setEmployeeList(resEmployee?.employeeResponseValueLabel);
      // setFilteredAssignedTo(resEmployee?.employeeResponseValueLabel);
    })();
  }, []);
  // console.log("employeeList1", employeeList);

  // const handleEdit = async (values) => {
  //   setIsSubmitting(true);
  //   try {
  //     const res = await patchData({
  //       endpoint: "Task/editTask",
  //       token: cookies.e_t,
  //       data: {
  //         ...values,
  //         created_by: initialData?.created_by,
  //         subtasks: subtask.subtasks,
  //         ...(values.recurrence_type && values.start_date && values.end_time
  //           ? { is_recurring: true }
  //           : {}),
  //       },
  //       params: { task_id: initialData?.id },
  //     });

  //     if (res.status) {
  //       toast.success("Task Updated Successfully", {
  //         style: confimationStyles,
  //         duration: 1000,
  //       });
  //       refetchData();
  //     } else {
  //       toast.error(res.message, { style: confimationStyles, duration: 1000 });
  //     }

  //     onClose();
  //   } catch (error) {
  //     toast.error("Error Updating Task", { style: errorStyles });
  //   } finally {
  //     setIsSubmitting(false);
  //   }
  // };

  const handleEdit = async (values, endRepeats) => {
    setIsSubmitting(true);
    try {
      // Handle recurring task operations
      if (endRepeats) {
        // Case 1: End recurring task
        const endRepeatRes = await postData({
          endpoint: "Task/endRepeats",
          params: { task_id: initialData?.id },
          token: cookies.e_t,
        });

        if (endRepeatRes && endRepeatRes?.data?.status === true) {
          toast.success("Repeats ended successfully", {
            style: confimationStyles,
            duration: 1000,
          });
        } else {
          toast.error("Failed to end repeats", {
            style: errorStyles,
            duration: 1000,
          });
          setIsSubmitting(false);
          onClose();
          return;
        }
      } else if (
        values.recurrence_type &&
        values.start_date &&
        values.end_time &&
        !initialData.is_recurring
      ) {
        const recurringRes = await postData({
          endpoint: "Task/createRecurringTask",
          data: {
            // task_id: initialData?.id,
            // is_recurring: true,
            // recurrence_type: values.recurrence_type,
            // start_date: values.start_date,
            // end_time: values.end_time,
            task_id: initialData?.id,
            is_recurring: values.is_recurring,
            recurrence_type: values.recurrence_type,
            start_date: values.start_date,
            end_time: values.end_time,
            repeat_interval: values.repeat_interval,
            week_days: values.week_days,
            month_days: values.month_days,
            skip_weekends: values.skip_weekends,
            due_date_offset: values.due_date_offset,
            custom_due_date_offset: values.custom_due_date_offset,
            end_condition: values.end_condition,
            default_status: values.default_status,
          },
          token: cookies.e_t,
        });

        if (recurringRes && recurringRes?.data?.status === true) {
          toast.success("Repeats Created successfully", {
            style: confimationStyles,
            duration: 1000,
          });
        }

        if (recurringRes && recurringRes?.data?.status !== true) {
          toast.error("Failed to create recurring task", {
            style: errorStyles,
            duration: 1000,
          });
          setIsSubmitting(false);
          onClose();
          return;
        }
      }

      // Proceed with task edit
      const editRes = await patchData({
        endpoint: "Task/editTask",
        token: cookies.e_t,
        data: {
          ...values,
          created_by: initialData?.created_by,
          subtasks: subtask.subtasks,
          is_recurring: endRepeats
            ? false
            : values.recurrence_type && values.start_date && values.end_time
            ? true
            : initialData?.is_recurring || false,
        },
        params: { task_id: initialData?.id },
      });

      if (editRes.status) {
        toast.success("Task Updated Successfully", {
          style: confimationStyles,
          duration: 1000,
        });
        refetchData();
      } else {
        toast.error(editRes.message, {
          style: confimationStyles,
          duration: 1000,
        });
      }

      onClose();
    } catch (error) {
      toast.error("Error Updating Task", {
        style: errorStyles,
        duration: 1500,
      });
    } finally {
      setIsSubmitting(false);
      setEndRepeats(false);
    }
  };

  const newListsAssignTo = async (option) => {
    try {
      const res = await getData({
        endpoint: "Employee/GetAllEmployeesValueLabel",
        params: {
          project_id: option,
          status: JSON.stringify(["Active"]),
          // employee_id: cookies.euid,
        },
        token: cookies.e_t,
      });

      if (res) {
        let employeeList = res?.data?.employeeResponseValueLabel || [];
        const currentUserExists = employeeList.some(
          (employee) => employee.value === cookies.euid
        );

        if (!currentUserExists && cookies.euid) {
          employeeList = [
            ...employeeList,
            {
              value: cookies.euid,
              label: decodeCookieValue(cookies.e_n),
            },
          ];
        }

        setFilteredAssignedTo(employeeList);
      }
    } catch (err) {
      toast.error("Error Creating Task", { style: errorStyles });
    }
  };

  const newListsAssignTeam = async (option) => {
    try {
      if (!option) {
        setFilteredAssignedTo(employeeList);
        return;
      }

      const res = await getData({
        endpoint: "Team/getAllTeamsList",
        params: {
          project_id: option,
        },
        token: cookies.e_t,
      });
      if (res) {
        setFilteredAssignedTeams(res?.data?.teams);
      }
    } catch (err) {
      toast.error("Error Creating Task", { style: errorStyles });
    }
  };

  const handleEditSubtask = (subtask) => {
    setSubtaskOpen(true);
    setSubtask((prev) => ({
      ...prev,
      editingSubtask: subtask,
    }));
  };

  const handleDeleteSubtask = async (subtaskId) => {
    if (initialData?.id && !subtaskId.toString().startsWith("temp-")) {
      try {
        const res = await deleteData({
          endpoint: "Subtask/deleteSubtask",
          params: { id: subtaskId },
          token: cookies.e_t,
        });

        if (res) {
          toast.success("Subtask Deleted Successfully", {
            style: confimationStyles,
            duration: 1000,
          });
          setSubtask((prev) => ({
            ...prev,
            subtasks: prev.subtasks.filter((item) => item.id !== subtaskId),
          }));
          refetchData();
          setDirtyFlag(true);
        }
      } catch (err) {
        toast.error("Error Deleting Subtask", { style: errorStyles });
      }
    } else {
      setSubtask((prev) => ({
        ...prev,
        subtasks: prev.subtasks.filter((item) => item.id !== subtaskId),
      }));
      toast.success("Subtask Removed", {
        style: confimationStyles,
        duration: 1000,
      });
      setDirtyFlag(true);
    }
    setIsDeleteModalOpen(false);
  };

  const handleUpdateSubtaskStatus = async (
    subtaskId,
    newStatus,
    originalStatus
  ) => {
    if (!initialData?.id || subtaskId.toString().startsWith("temp-")) {
      // Update temporary subtask status
      setSubtask((prev) => ({
        ...prev,
        subtasks: prev.subtasks.map((item) =>
          item.id === subtaskId ? { ...item, status: newStatus } : item
        ),
      }));
      setDirtyFlag(true);
      toast.success("Subtask Status Updated", {
        style: confimationStyles,
        duration: 1000,
      });
      return;
    }

    setSubtask((prev) => ({
      ...prev,
      subtasks: prev.subtasks.map((item) =>
        item.id === subtaskId ? { ...item, status: newStatus } : item
      ),
    }));

    try {
      const res = await patchData({
        endpoint: "Subtask/updateSubtaskEntity",
        data: {
          status: newStatus,
          task_id: initialData.id,
        },
        token: cookies.e_t,
        params: { id: subtaskId },
      });

      if (res) {
        toast.success("Subtask Status Updated Successfully", {
          style: confimationStyles,
          duration: 1000,
        });
        setDirtyFlag(true);
        refetchData();
      }
    } catch (err) {
      // Revert on error
      setSubtask((prev) => ({
        ...prev,
        subtasks: prev.subtasks.map((item) =>
          item.id === subtaskId ? { ...item, status: originalStatus } : item
        ),
      }));
      toast.error("Error Updating Subtask Status", { style: errorStyles });
    }
  };

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values, { resetForm }) => {
          if (initialData) {
            handleEdit(values, endRepeats);
          } else {
            handleSubmit(values, { resetForm });
          }
          onFormDirty(false);
        }}
        validateOnBlur={false}
        validateOnChange={false}
        enableReinitialize={true}
      >
        {({
          values,
          setFieldValue,
          touched,
          errors,
          setFieldTouched,
          handleBlur,
          dirty,
        }) => (
          <>
            <FormObserver onFormDirty={onFormDirty} />
            <Form className="mt-1">
              <div className="row gx-4">
                <InputLayout>
                  <label className="required-field">Project</label>
                  <SelectDropdown
                    isClearable={true}
                    onClear={() => {
                      setFieldValue("project_id", null);
                      setFilteredAssignedTeams(teamList);
                      setFilteredAssignedTo(employeeList);
                    }}
                    data={Projects}
                    onChange={(option) => {
                      setFieldValue("project_id", option);
                      if (option) {
                        newListsAssignTo(option);
                        newListsAssignTeam(option);
                      }
                    }}
                    selectedValue={values.project_id}
                    isDisabled={!!information?.id}
                  />
                  <Error error={errors.project_id} />
                </InputLayout>
                <InputLayout>
                  <label htmlFor="">Due Date</label>
                  <DateSelector
                    placeholder=""
                    selectedDate={initialData?.due_date}
                    onChange={(date) => {
                      const istDate = new Date(date);
                      const utcDate = new Date(
                        istDate.getTime() - istDate.getTimezoneOffset() * 60000
                      );
                      setFieldValue("due_date", utcDate.toISOString());
                    }}
                    handleBlur={(e) => {
                      setFieldTouched("due_date", true);
                      handleBlur(e);
                    }}
                    disablePast={isAdmin ? false : true}
                    disabled={initialData?.is_recurring}
                    isError={touched.due_date && errors.due_date}
                  />
                </InputLayout>
              </div>
              <div className="row gx-4 mt-4">
                <InputLayout>
                  <label className="required-field">Status</label>
                  <SelectDropdown
                    isClearable={true}
                    onClear={() => {
                      setFieldValue("status", null);
                      setPendingStatus(null);
                    }}
                    data={TaskStatus}
                    onChange={(option) => {
                      if (option === "Completed") {
                        if (confirmcomplete !== 0) {
                          // Require confirmation before completing
                          setPendingStatus(option);
                          setIsConfirmCompleteModalOpen(true);
                        } else {
                          // Directly complete the task and open log modal
                          setFieldValue("status", option);
                          setPendingStatus(null);
                          setLogTimerOpen(true);
                        }
                      } else {
                        // For other statuses, set directly
                        setFieldValue("status", option);
                        setPendingStatus(null);
                      }
                    }}
                    selectedValue={pendingStatus || values.status} // Use pendingStatus if set, else values.status
                  />
                  <Error error={errors.status} />
                </InputLayout>
                <InputLayout>
                  <label className="required-field">Priority</label>
                  <SelectDropdown
                    isClearable={true}
                    onClear={() => setFieldValue("priority", null)}
                    data={Priorities}
                    onChange={(option) => setFieldValue("priority", option)}
                    selectedValue={values.priority}
                  />
                  <Error error={errors.priority} />
                </InputLayout>
              </div>
              <div className="row gx-4 mt-4">
                <InputLayout>
                  <label className="">Assigned to</label>
                  <SelectDropdown
                    data={filteredAssignedTo}
                    multiSelect={true}
                    onChange={(option) =>
                      setFieldValue("assigned_employees", option)
                    }
                    selectedValue={values.assigned_employees}
                    onClear={() => setFieldValue("assigned_employees", [])}
                    sError={
                      touched.assigned_employees && errors.assigned_employees
                    }
                  />
                </InputLayout>
                <InputLayout>
                  <label className="">Assigned Teams</label>
                  <SelectDropdown
                    data={filteredAssignedTeams}
                    multiSelect={true}
                    onChange={(option) =>
                      setFieldValue("assigned_teams", option)
                    }
                    selectedValue={values.assigned_teams}
                    onClear={() => setFieldValue("assigned_teams", [])}
                    isError={touched.assigned_teams && errors.assigned_teams}
                  />
                </InputLayout>
              </div>
              <div className="row gx-4 mt-4">
                <InputLayout>
                  <label className="required-field">Task Title</label>
                  <Field name="name" />
                  <Error error={errors.name} />
                </InputLayout>
                <InputLayout>
                  <label className="required-field">Client Name</label>
                  <ClientDropdown
                    clientOptions={client}
                    onClientListChange={setClient}
                    values={values}
                    setFieldValue={setFieldValue}
                    isError={touched.client_id && errors.client_id}
                    refetchClientList={refetchClientList}
                    error={errors.client_id}
                  />
                </InputLayout>
              </div>
              <div className="mt-3">
                <InputLayout>
                  <QuillEditor
                    label="Description"
                    value={values.description}
                    onChange={(value) => setFieldValue("description", value)}
                    onBlur={() => setFieldTouched("description", true)}
                    placeholderText="Enter project description..."
                    height="180px"
                    hp="70%"
                    className="quill-editor-custom"
                  />
                  <Error error={errors.description} />
                </InputLayout>
              </div>
              <div className="d-flex gap-3 mt-2">
                <AttachmentComponent
                  onUploadComplete={(s3Links) => {
                    setFieldValue("media", [...values.media, ...s3Links]);
                  }}
                  onFileRemove={(removedLink) => {
                    setFieldValue(
                      "media",
                      values.media.filter((link) => link !== removedLink)
                    );
                  }}
                  initialAttachments={values.media.map((link, index) => ({
                    id: index,
                    name: `File ${index + 1}`,
                    s3Link: link,
                  }))}
                  alreadyAdded={values?.media}
                  setUploadingState={setIsUploading}
                />
                {initialData ? (
                  <LogTime
                    mytask={mytask}
                    logData={logData}
                    setLogData={setLogData}
                    task_id={initialData?.id}
                    open={logTimerOpen}
                    setOpen={setLogTimerOpen}
                    refetchData={refetchData}
                    dirtyFlag={setDirtyFlag}
                    ispresent={isAllowed}
                  />
                ) : null}
                <Recurring
                  setFieldValue={setFieldValue}
                  values={values}
                  setEndRepeats={setEndRepeats}
                  status={TaskStatus}
                  initialValues={initialData}
                />
                <SubtaskView
                  setSubtaskOpen={setSubtaskOpen}
                  logData={subtask}
                  setLogData={setSubtask}
                  task_id={initialData?.id}
                  open={subtaskOpen}
                  setOpen={setSubtaskOpen}
                  name={values.name}
                  refetchData={refetchData}
                  dirtyFlag={setDirtyFlag}
                  disabled={values.status === "Completed"}
                />
              </div>
              {values?.start_date || values?.end_time ? (
                <div className="mt-3">
                  <label htmlFor="">Recurring</label>
                  <p className="btn-outline-dark btn-div">
                    <div>
                      Repeat{" "}
                      <strong>
                        {frequencyOptions.find(
                          (option) => option.value === values.recurrence_type
                        )?.label || values.type}
                      </strong>
                        from{" "}
                      <strong>
                        {moment(values.start_date).format("DD/MM/YYYY")}
                      </strong>
                        to{" "}
                      <strong>
                        {moment(values.end_time).format("DD/MM/YYYY")}
                      </strong>
                    </div>
                  </p>
                </div>
              ) : null}

              {subtask.subtasks?.length > 0 && (
                <div className="mt-3">
                  <label>Subtasks</label>
                  <div className="subtask-list">
                    {subtask.subtasks.map((subtaskItem, index) => (
                      <div
                        key={subtaskItem.id || index}
                        className="subtask-item d-flex p-2 mb-2 border rounded align-items-start flex-column"
                      >
                        <div className="subtask-info w-100">
                          <div className="d-flex align-items-center gap-2 mb-2">
                            <div className="subtask-name fw-bold">
                              #{index + 1}: {subtaskItem.title}
                            </div>
                            <div className="ms-auto d-flex gap-3">
                              <div className="edit-icon-wrapper">
                                <Edit
                                  color="black"
                                  size={16}
                                  onClick={() => handleEditSubtask(subtaskItem)}
                                  className="edit-icon"
                                />
                              </div>
                              <div className="delete-icon-wrapper">
                                <Trash2
                                  color="black"
                                  size={16}
                                  onClick={() => {
                                    setSelectedSubtaskForDeletion(
                                      subtaskItem.id
                                    );
                                    setIsDeleteModalOpen(true);
                                  }}
                                  className="delete-icon"
                                />
                              </div>
                            </div>
                          </div>
                          {subtaskItem.description && (
                            <div className="subtask-description text-muted small mb-2">
                              {subtaskItem.description}
                            </div>
                          )}
                          {subtaskItem.due_date && (
                            <div className="subtask-due-date small text-muted mb-2">
                              Due:{" "}
                              {moment(subtaskItem.due_date).format(
                                "DD/MM/YYYY"
                              )}
                            </div>
                          )}
                          {subtaskItem.media &&
                            subtaskItem.media.length > 0 && (
                              <div className="subtask-attachments small text-muted mb-2">
                                <i className="bi bi-paperclip me-1"></i>
                                {subtaskItem.media.length}{" "}
                                {subtaskItem.media.length === 1
                                  ? "attachment"
                                  : "attachments"}
                              </div>
                            )}
                          <div className="subtask-status mt-1">
                            {initialData?.id ? (
                              <StatusSelector
                                currentStatus={subtaskItem.status}
                                onStatusChange={(newStatus) =>
                                  handleUpdateSubtaskStatus(
                                    subtaskItem.id,
                                    newStatus,
                                    subtaskItem.status
                                  )
                                }
                              />
                            ) : (
                              <StatusBackground status={subtaskItem.status} />
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {values?.media?.length > 0 && (
                <div className="mt-3">
                  <label htmlFor="">Attachments</label>
                  <UploadedFilesComponent
                    alreadyAdded={values?.media}
                    onFileRemove={(removedLink) => {
                      setFieldValue(
                        "media",
                        values.media.filter((link) => link !== removedLink)
                      );
                    }}
                  />
                </div>
              )}
              {logData?.length > 0 && (
                <div className="mt-3">
                  <label htmlFor="">Logged time</label>
                  <LoggedEntries
                    logData={logData}
                    setLogData={setLogData}
                    task_id={initialData?.id}
                    dirtyFlag={setDirtyFlag}
                    refetchData={refetchData}
                  />
                </div>
              )}
              <div className="drawer-footer mt-4">
                <button
                  type="button"
                  className="btn btn-outline-primary"
                  onClick={onClose}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={isSubmitting || (!dirty && !dirtyFlag)}
                >
                  {initialData ? "Update" : "Save"}
                </button>
              </div>
              {isConfirmCompleteModalOpen && (
                <DeleteModal
                  name="task"
                  type="Confirm"
                  id="confirm-complete"
                  isActive={isConfirmCompleteModalOpen}
                  onClose={() => {
                    setPendingStatus(null); // Clear pending status to revert dropdown
                    setIsConfirmCompleteModalOpen(false);
                  }}
                  title="Task Completion"
                  description="Do you want to complete this task even though it has unfinished subtasks? All subtasks will be marked as completed."
                  onClick={() => {
                    setFieldValue("status", pendingStatus); // Confirm status change
                    setPendingStatus(null);
                    setLogTimerOpen(true);
                    setIsConfirmCompleteModalOpen(false);
                  }}
                />
              )}
            </Form>
          </>
        )}
      </Formik>
      {isDeleteModalOpen && selectedSubtaskForDeletion && (
        <DeleteModal
          name={"subtask"}
          id={selectedSubtaskForDeletion.id}
          isActive={isDeleteModalOpen}
          onClose={() => setIsDeleteModalOpen(false)}
          title="Subtask"
          onClick={() => handleDeleteSubtask(selectedSubtaskForDeletion)}
        />
      )}
    </>
  );
};

const FormObserver = ({ onFormDirty }) => {
  const { dirty } = useFormikContext();
  useEffect(() => onFormDirty(dirty), [dirty, onFormDirty]);
  return null;
};

export default TaskForm;
